import { createReducer } from '@topconagriculture/frontend-utils';

import {
  deleteSelectedWeighbridgeTickets,
  deleteWeigbridgeTicket,
  emptyWeighbridgeTicketsList,
  getWeighbridgeTicketList,
  getWeighbridgeTicketTransactions,
  updateWeigbridgeTicket,
} from './weighbridge.actions';
import { WeighbridgeTicket } from './weighbridge.types';

export type WeighbridgeState = {
  openTickets: WeighbridgeTicket[];
  processedTickets: WeighbridgeTicket[];
  transactionsInfo: { [key in string]: WeighbridgeTicket[] };
};

export const initialState: WeighbridgeState = {
  openTickets: [],
  processedTickets: [],
  transactionsInfo: {},
};

const weighbridgeReducer = createReducer(initialState, {
  [getWeighbridgeTicketList.done.type]: (
    state: WeighbridgeState,
    action: ReturnType<typeof getWeighbridgeTicketList.done>,
  ) => {
    const { status } = action.payload.params;
    return { ...state, [status === 'processed' ? 'processedTickets' : 'openTickets']: action.payload.result };
  },
  [updateWeigbridgeTicket.done.type]: (
    state: WeighbridgeState,
    action: ReturnType<typeof updateWeigbridgeTicket.done>,
  ) => {
    const index = state.openTickets.findIndex((ticket) => ticket.id === action.payload.params.id);
    const openTickets = [...state.openTickets];
    openTickets[index] = action.payload.result;
    const newState = {
      ...state,
      openTickets,
    };
    return newState;
  },
  [deleteWeigbridgeTicket.done.type]: (
    state: WeighbridgeState,
    action: ReturnType<typeof deleteWeigbridgeTicket.done>,
  ) => {
    const id = action.payload.params;
    const openTickets = state.openTickets.filter((ticket) => ticket.id !== id);
    return { ...state, openTickets };
  },
  [deleteSelectedWeighbridgeTickets.done.type]: (
    state: WeighbridgeState,
    action: ReturnType<typeof deleteSelectedWeighbridgeTickets.done>,
  ) => {
    const ids = action.payload.params;
    const openTickets = state.openTickets.filter((ticket) => !ids.includes(ticket.id));
    return { ...state, openTickets };
  },
  [getWeighbridgeTicketTransactions.done.type]: (
    state: WeighbridgeState,
    action: ReturnType<typeof getWeighbridgeTicketTransactions.done>,
  ) => {
    const tickets = action.payload.result;
    if (tickets.length === 0) {
      return { ...state };
    }

    const tapIngredientId = tickets[0].tapIngredientId;

    const oldTickets = state.transactionsInfo[tapIngredientId] || [];

    return {
      ...state,
      transactionsInfo: { ...state.transactionsInfo, [tapIngredientId]: [...oldTickets, ...tickets] },
    };
  },
  [emptyWeighbridgeTicketsList.type]: (state: WeighbridgeState) => {
    return {
      ...state,
      transactionsInfo: {},
    };
  },
});

export default weighbridgeReducer;
